import React, { useEffect, useState } from 'react';
import './styles.scss';

type Filter = {
  title: string;
  sectionsToHide: string[];
}

type HomeFiltersProps = {
  filter: Filter[] | null;
};

export function HomeFilters({ filter }: HomeFiltersProps) {
  if (!filter) return null;

  const [filterActive, setFilterActive] = useState<Filter | null>(null);

  useEffect(() => {
    const homeContent = document?.querySelectorAll('#home-content > *');
    homeContent.forEach((content) => {
      content.classList.remove('hidden');
    });

    if (filterActive) {
      filterActive.sectionsToHide.forEach(htmlId => {
        const item = document?.getElementById(htmlId);
        if (!item) return;
        item.classList.add('hidden')
      });
    }
  }, [filterActive]);

  function handleClickFilter(item: Filter) {
    if (item.title === filterActive?.title) {
      setFilterActive(null);
    } else {
      setFilterActive(item);
    }
  }

  return (
    <div className='home-filters'>
      <div className='filters-buttons'>
        {filter.map((item, index) => (
          <button
            className={`tag-button ${item.title === filterActive?.title ? 'active' : ''}`}
            key={`filter${item.title}${index}`}
            onClick={() => handleClickFilter(item)}
          >
            {item.title}
            <span />
          </button>
        ))}
      </div>
      <p>Filter the information below using these tags</p>
    </div>
  );

}
